
import { Options, Vue } from "vue-class-component";
import { FlagsBulkDownloadData } from "@/feature-flags/flags-bulk-download-data";
import { FlagsBulkDownloadTemplate } from "@/feature-flags/flags-bulk-download-template";

@Options({
  components: {}
})
export default class Client extends Vue {
  get tabs() {
    const tabs: Array<{ name: string; title: string }> = [];

    if (this.showTabsExisting) {
      tabs.push({ name: "existing-data", title: "Data Tersedia" });
    }
    if (this.showTabsTemplate) {
      tabs.push({ name: "template", title: "Template" });
    }
    return tabs;
  }

  get showTabsExisting() {
    return Object.values(FlagsBulkDownloadData).some((flag: any) =>
      typeof flag?.isEnabled === "function"
        ? flag.isEnabled()
        : !!flag?.getValue?.()
    );
  }

  get showTabsTemplate() {
    return Object.values(FlagsBulkDownloadTemplate).some((flag: any) =>
      typeof flag?.isEnabled === "function"
        ? flag.isEnabled()
        : !!flag?.getValue?.()
    );
  }

  changeTabs(value: string) {
    this.$router.push({
      name: value
    });
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }
}
